var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditExtraSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M30.623 8.242c-7.26-2.104-7.26 5.503-2.678 5.401 4.488-.1 5.049 7.163-2.933 4.951M27.77 6.628v.664M27.77 19.596v.664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.1 25.508l3.777-.034s4.078 1.958 6.232 3.116c2.897 1.558.316 5.466-2.323 4.129-2.46-1.246-3.89-2.103-3.89-2.103"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M25.972 30.187s4.1-2.064 7.134-3.583c2.358-1.18 3.422-.786 4.264.078.683.701 1.435 2.493-1.398 4.012-3.49 1.871-13.037 7.245-13.037 7.245L8.918 33.421v-7.894"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 4.125,
    cy: 26.526,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditExtraSalary);
export default __webpack_public_path__ + "static/media/editExtraSalary.56f397f9e5a81ebe5a5eb5cd7839066d.svg";
export { ForwardRef as ReactComponent };